import DayDesktop from './DayDesktop';

/**
 * MonthGridDesktop - Desktop version of month grid
 * Shows calendar in a 7-column grid with square day cells
 */
function MonthGridDesktop({ monthString, calendarData, userId, calendarId = null }) {
  const [year, month] = monthString.split('-').map(Number);
  const daysInMonth = new Date(year, month, 0).getDate();
  const firstDayOfMonth = new Date(year, month - 1, 1).getDay();

  // Generate empty cells for days before the first day of the month
  const emptyCells = Array(firstDayOfMonth).fill(null);

  // Generate day cells for the month
  const dayCells = [];
  for (let day = 1; day <= daysInMonth; day++) {
    const dateStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    dayCells.push(dateStr);
  }

  // Get month name for display
  const monthName = new Date(year, month - 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });

  return (
    <div className="mb-6 w-full">
      {/* Month header */}
      <h3 className="mb-3 text-lg font-semibold px-4">{monthName}</h3>

      {/* Day of week headers */}
      <div className="grid grid-cols-7 gap-1 mb-2 px-4">
        {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
          <div key={day} className="text-center text-xs font-medium text-muted-foreground">
            {day}
          </div>
        ))}
      </div>

      {/* Calendar grid */}
      <div className="grid grid-cols-7 gap-1 px-4">
        {/* Empty cells for days before first of month */}
        {emptyCells.map((_, index) => (
          <div key={`empty-${index}`} className="aspect-square" />
        ))}

        {/* Day cells */}
        {dayCells.map((dateStr) => (
          <DayDesktop
            key={dateStr}
            dateStr={dateStr}
            dayData={calendarData?.[dateStr]}
            userId={userId}
            calendarId={calendarId}
          />
        ))}
      </div>
    </div>
  );
}

export default MonthGridDesktop;
